import { Video, Sprout, UtensilsCrossed, Star } from "lucide-react";
import { FadeUp, MaskedLines, ChapterNumber } from "@/components/Reveal";
import { useLang, hlLines } from "@/i18n/LanguageContext";

const META = [
  { id: "cameras", icon: Video, tone: "bg-brand/10 text-brand" },
  { id: "reggio", icon: Sprout, tone: "bg-leaf/15 text-leaf" },
  { id: "meals", icon: UtensilsCrossed, tone: "bg-honey/20 text-honey" },
  { id: "trs", icon: Star, tone: "bg-brick/10 text-brick" },
];

export const Features = () => {
  const { t } = useLang();
  const items = t("home.features");
  return (
    <section className="mx-auto max-w-7xl px-4 pt-24 sm:px-6 lg:pt-32" data-testid="home-features">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-start">
        <FadeUp className="lg:col-span-4">
          <ChapterNumber n={t("home.featChapter")} />
          <h2 className="mt-4 font-display text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
            <MaskedLines lines={hlLines(t("home.featLines"))} />
          </h2>
        </FadeUp>
        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-8">
          {META.map((m, i) => (
            <FadeUp key={m.id} delay={i * 0.08}>
              <div className="flex h-full gap-4 rounded-3xl border border-ink/10 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-testid={`feature-${m.id}`}>
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${m.tone}`}>
                  <m.icon className="h-6 w-6" />
                </span>
                <div>
                  <h3 className="font-display text-lg font-semibold">{items[i].title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-mist">{items[i].desc}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
